import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IEditDocumentResponse } from './IEditDocumentResponse';
import { IEditDocumentParams } from './IEditDocumentParams';

export const editDocument = (params: IEditDocumentParams) : AxiosPromise<IEditDocumentResponse> => {
  return Fetch().then(axios => axios.post('documents/update', params));
};
